<template>
    <div class="w-full bg-icon-light p-5 lg:p-20 ">
        <div class="flex flex-col max-w-7xl mx-auto">
            <div class="flex items-center space-x-2">
                <svg
                    width="24"
                    height="21"
                    viewBox="0 0 30 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.049 1.92664C14.3483 1.00538 15.6517 1.00538 15.951 1.92664L18.368 9.36437C18.5019 9.77636 18.8858 10.0553 19.319 10.0553L27.1396 10.0556C28.1083 10.0556 28.5111 11.2952 27.7274 11.8646L21.4006 16.4617C21.0501 16.7163 20.9035 17.1676 21.0373 17.5796L23.4537 25.0176C23.753 25.9388 22.6986 26.7049 21.9149 26.1356L15.5878 21.539C15.2373 21.2844 14.7627 21.2844 14.4122 21.539L8.08508 26.1356C7.30138 26.7049 6.24695 25.9388 6.54626 25.0176L8.96267 17.5796C9.09652 17.1676 8.94987 16.7163 8.59942 16.4617L2.27261 11.8646C1.48894 11.2952 1.8917 10.0556 2.86038 10.0556L10.681 10.0553C11.1142 10.0553 11.4981 9.77636 11.632 9.36437L14.049 1.92664Z"
                        fill="#E6F2F3"
                        stroke="#212121"
                        stroke-width="2"
                    />
                </svg>
              <editable-headline field="highlights" default="Highlights" :width="true"/>
            </div>
            <div v-if="highlights.length > 0" class="w-full">
                <Cards
                    class="mt-4"
                    @remove="removeHighlight"
                    :cards="highlights"
                    :card-highlight="true"
                />
            </div>
            <div v-else class="py-10 relative">
                <ul role="list" class="w-full grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                    <li class="col-span-1 flex flex-col rounded-lg bg-white border border-gray-200 overflow-hidden opacity-50">
                        <div class="h-48 bg-gray-200"></div>
                        <div class="h-32"></div>
                    </li>
                    <li class="col-span-1 hidden lg:flex flex-col rounded-lg bg-white border border-gray-200 overflow-hidden opacity-50">
                        <div class="h-48 bg-gray-200"></div>
                        <div class="h-32"></div>
                    </li>
                    <li class="col-span-1 hidden xl:flex flex-col rounded-lg bg-white border border-gray-200 overflow-hidden opacity-50">
                        <div class="h-48 bg-gray-200"></div>
                        <div class="h-32"></div>
                    </li>

                    <li class="col-span-1 hidden 2xl:flex flex-col rounded-lg bg-white border border-gray-200 overflow-hidden opacity-50">
                        <div class="h-48 bg-gray-200"></div>
                        <div class="h-32"></div>
                    </li>
                </ul>
                <div class="absolute inset-0 flex justify-center items-center">
                    <div class="bg-white text-gray-900 rounded-md border border-gray-800 p-4 flex space-x-3">
                        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mt-1">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2V10C16 11.1046 15.1046 12 14 12H9L4 16V12H2C0.895431 12 0 11.1046 0 10V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2ZM5 5H3V7H5V5ZM7 5H9V7H7V5ZM13 5H11V7H13V5Z" fill="#9CA3AF"/>
                        </svg>
                        <p class="text-sm w-52">
                            Add highlights to your proposal by clicking the star next to the activity in the proposal program.
                            <br><br>Maximum 6 cards.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { useProposalOldStore } from '@/Stores/ProposalOld'
import {computed} from "vue";
import Cards from "@/ComponentsDeprecated/Cards/DestinationCards"
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";

const store = useProposalOldStore();

const highlights = computed(() => [].concat(store.activities.filter(activity => activity.highlighted)).concat(store.eateries.filter(eatery => eatery.highlighted)));

function removeHighlight(highlight) {
    axios.post(route('api.proposal.highlight.toggle', {proposal: store.proposal.id, itinerary: highlight.id}))
        .then((response) => {
            if(response.data) {
                if(highlight.type === 'activity') {
                    const index = store.activities.findIndex(obj => {
                        return obj.id === highlight.id;
                    });
                    store.activities[index].highlighted = !store.activities[index].highlighted;
                }
                else if(highlight.type === 'eatery') {
                    const index = store.eateries.findIndex(obj => {
                        return obj.id === highlight.id;
                    });
                    store.eateries[index].highlighted = !store.eateries[index].highlighted;
                }
            }
        })
}
</script>
